import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Layout from './components/Layout';
import Login from './pages/Login'; // ✅ Import Login
import Home from './pages/Home';
import PatientProfile from './pages/PatientProfile';
import SystemLog from './pages/SystemLog';
import ListOfPatients from './pages/ListOfPatients';
import RecycleBin from './pages/RecycleBin';
import HistoryPage from './pages/History'; // ✅ Import
import Tracker from './pages/Tracker';
import TrackerDetails from './pages/TrackerDetails';

function App() {
  // Check if user is logged in (persisted in localStorage)
  const [isAuthenticated, setIsAuthenticated] = useState(
    localStorage.getItem('isAuthenticated') === 'true'
  );

  // Logout Function
  const handleLogout = () => {
    localStorage.removeItem('isAuthenticated');
    localStorage.removeItem('user');
    setIsAuthenticated(false);
  };

  return (
    <Router>
      <Routes>
        {/* Login Route (Public) */}
        <Route
          path="/login"
          element={!isAuthenticated ? <Login setIsAuthenticated={setIsAuthenticated} /> : <Navigate to="/" />}
        />

        {/* Protected Routes (Wrapped in Layout) */}
        {isAuthenticated ? (
          <Route element={<Layout onLogout={handleLogout} />}>
            <Route path="/" element={<Home />} />
            <Route path="/patients" element={<ListOfPatients />} />
            <Route path="/patient/:id" element={<PatientProfile />} />
            <Route path="/doctors" element={<Navigate to="/patients" replace />} />
            <Route path="/refills" element={<Navigate to="/patients" replace />} />
            <Route path="/history" element={<HistoryPage />} /> {/* ✅ Added Route */}
            <Route path="/tracker" element={<Tracker />} />
            <Route path="/tracker/:id" element={<TrackerDetails />} />
            <Route path="/logs" element={<SystemLog />} />
            <Route path="/recycle-bin" element={<RecycleBin />} />
          </Route>
        ) : (
          // Redirect any unknown route to login
          <Route path="*" element={<Navigate to="/login" />} />
        )}
      </Routes>
    </Router>
  );
}

export default App;